module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-1-pod_600px_width-0_1-@1x.f7fb98b8.png";